import { render, staticRenderFns } from "./IconSjwk.vue?vue&type=template&id=442a12d4"
import script from "./IconSjwk.vue?vue&type=script&lang=js"
export * from "./IconSjwk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports